export const resizeStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "solid 2px #fff",
    background: "#ffffffff"
};

export const initialSettings = {
    content: {
        allowNumbers: false,
        maxWords: 100,
        stemmer: 'lancaster',
        stopwordsInput: '',
    },
    wordcloud: {
        colors: [
            '#1f77b4',
            '#ff7f0e',
            '#2ca02c',
            '#d62728',
            '#9467bd',
            '#8c564b',
            '#e377c2',
            '#7f7f7f',
            '#bcbd22',
            '#17becf',
        ],
        fontFamily: 'open sans',
        fontSizes: [10, 64],
        padding: 2,
        rotations: 3,
        rotationAngles: [0, 90],
        spiral: 'archimedean',
        scale: 'sqrt',
        transitionDuration: 500,
        // Non-configurable
        deterministic: true,
        enableOptimizations: true,
        enableTooltip: true,
    },
};